import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

const EMPTY_ARRAY = [];
const EMPTY_OBJ = {};

export default function useAgreementSelector() {
  const AgreementListData =
    useSelector((state) => state.Agreement.list_data?.agreements) || EMPTY_ARRAY; // List data
  const AgreementViewData = useSelector((state) => state.Agreement.view_data) || EMPTY_OBJ; // View
  const AgreementEdit = useSelector((state) => state.Agreement.edit_data) || EMPTY_OBJ; // edit

  const BankTypeList = useSelector((state) => state.Agreement.bank_type_data) || EMPTY_ARRAY; // bank type list
  const AgreementDocTypes =
    useSelector((state) => state.Agreement.agreement_doc_types) || EMPTY_ARRAY; // agreement doc types
  const InvoiceModeList = useSelector((state) => state.Agreement.invoice_mode_data) || EMPTY_ARRAY; // invoice mode list

  const BankTypeDrop =
    useMemo(
      () =>
        (BankTypeList || EMPTY_ARRAY)?.map((item) => ({
          label: item?.typeName,
          value: item?.typeId
        })),
      [BankTypeList]
    ) || EMPTY_ARRAY;

  const AgreementDocTypesDrop =
    useMemo(
      () =>
        (AgreementDocTypes || EMPTY_ARRAY)?.map((item) => ({
          label: item?.typeName,
          value: item?.typeId,
          typeCode: item?.typeCode
        })),
      [AgreementDocTypes]
    ) || EMPTY_ARRAY;

  const InvoiceModeDrop =
    useMemo(
      () =>
        (InvoiceModeList || EMPTY_ARRAY)?.map((item) => ({
          label: item?.typeName,
          value: item?.typeCode
        })),
      [InvoiceModeList]
    ) || EMPTY_ARRAY;

  return {
    AgreementListData,
    AgreementViewData,
    AgreementEdit,
    BankTypeList,
    BankTypeDrop,
    AgreementDocTypes,
    AgreementDocTypesDrop,
    InvoiceModeList,
    InvoiceModeDrop
  };
}
